import { render, staticRenderFns } from "./previewButton.vue?vue&type=template&id=10bead0c&scoped=true"
import script from "./previewButton.vue?vue&type=script&lang=js"
export * from "./previewButton.vue?vue&type=script&lang=js"
import style0 from "./previewButton.vue?vue&type=style&index=0&id=10bead0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bead0c",
  null
  
)

export default component.exports